import React from 'react';

import { h3, h4, h5 } from '../../fontSizes';
import { textLight, textLighter } from '../../colors';
import { smallMargin, mediumMargin } from '../../margins';

const Meal = ({ mealName, mealPrice, mealTitle, mealDescription }) => (
  <li
    css={`
      margin-bottom: ${mediumMargin};
    `}
  >
    {mealTitle &&
      mealTitle.length && (
        <h4
          css={`
            font-weight: 700;
            font-size: ${h4};
            margin-bottom: calc(${smallMargin} / 2);
          `}
        >
          {mealTitle}
        </h4>
      )}
    <h5
      css={`
        font-weight: 700;
        font-size: ${h5};
        color: ${textLight};
        margin-bottom: calc(${smallMargin} / 2);
      `}
    >
      {mealName}
    </h5>
    {mealDescription &&
      mealDescription.length && (
        <div
          css={`
            color: ${textLighter};
            margin-bottom: calc(${smallMargin} / 2);
          `}
        >
          {mealDescription}
        </div>
      )}
    {mealPrice &&
      mealPrice.length && (
        <div
          css={`
            color: ${textLight};
            margin-bottom: ${mediumMargin};
          `}
        >
          {mealPrice} kr
        </div>
      )}
  </li>
);

export const MenuPart = ({ subtitle, meals, className }) => (
  <section className={className}>
    <h3
      css={`
        font-weight: 700;
        margin-bottom: ${mediumMargin};
        font-size: ${h3};
      `}
    >
      {subtitle}
    </h3>
    <ul>{meals.map(meal => <Meal key={meal.mealName} {...meal} />)}</ul>
  </section>
);



// WEBPACK FOOTER //
// ./app/components/MenuSection/MenuPart.js